import React from 'react'
import { Helmet } from 'react-helmet-async';
import './Crm.css'
import Feedback from './feedback/Feedback'
import Uifooter from './UiFooter/Uifooter'
import Why from './why/Why'
import What from './What/What'
import Industry from './Industry/Industry'
import Whycrm from './Whycrm/Whycrm'
import Herocrm from './Herocrm/Herocrm'
import Service from './service/Services';
import CrmCounter from './crmcounter/CrmCounter';
const Crm = () => {
  return (
    <div id='crm'>
      <Helmet>
        <title>CRM Development Company | Custom CRM Solutions | BastionEx</title>
        <meta name="description" content="CRM development solutions for your business. Build powerful CRM systems to streamline operations and strengthen customer relationships." />
        <link rel="canonical" href="https://bastionex.net/crm-development" />
      </Helmet>
      <Herocrm />
      <Whycrm />
      <What />
      <Why />
       <CrmCounter/>
      <Feedback />
      <Service/>
      {/* 
      <Industry />   
      <Uifooter />  
      */}
      
    </div>
  )
}

export default Crm

